import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static targets = ["select"]
  static values = { url: String }

  connect() {
    this.tomSelect = new TomSelect(this.selectTarget, {
      create: false,
      maxItems: 1,
      maxOptions: 20,
      searchField: [],
      closeAfterSelect: true,
      plugins: {
        clear_button: {
          html: () => '<button type="button" class="clear-button" title="Clear member filter" aria-label="Clear member filter">&times;</button>'
        }
      },
      placeholder: "Type a member’s name",
      loadThrottle: 250,
      shouldLoad: query => query.trim().length >= 3,
      onType: () => {
        this.abortController?.abort()
        this.tomSelect.clearOptions()
      },
      load: (query, callback) => this.loadMembers(query, callback),
      onChange: () => this.element.requestSubmit(),
      render: {
        not_loading: () => '<div class="px-3 py-2 text-sm text-stone-500">Type at least 3 characters to find a member.</div>',
        no_results: () => '<div class="px-3 py-2 text-sm text-stone-500">No matching members found.</div>'
      }
    })
  }

  disconnect() {
    this.abortController?.abort()
    this.tomSelect?.destroy()
  }

  async loadMembers(query, callback) {
    this.abortController?.abort()
    const request = new AbortController()
    this.abortController = request
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("q", query.trim())
    try {
      const response = await fetch(url, { headers: { Accept: "application/json" }, signal: request.signal })
      if (!response.ok) throw new Error("Member search failed")
      const members = await response.json()
      callback(request.signal.aborted ? [] : members)
    } catch {
      callback()
    }
  }
}
